import type React from 'react'

const DateItem: React.FC<{ epoch: number }> = ({ epoch }) => {
  const date = new Date(epoch)
  return <>{date !== null ? date.toLocaleString('sv-SE') : '-'}</>
}

export default DateItem
